var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGymnastics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "18.166 17.183 19.147 15.354 18.114 13.576 19.147 11.628 18.515 10.079 17.164 10.771 16.321 14.433 15.199 15.354 15.567 13.759 15.199 11.86 16.132 9.149 18.515 8.566 19.974 10.079 20.713 10.919 23.056 11.412 25.079 13.759 25.274 16.736 25.68 17.83 24.971 18.055 23.934 19.234 22.198 19.077 20.758 20.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: ".418 27.8 5.055 30.615 3.861 41.002 5.094 47.301 10.189 49.049 9.737 50 2.179 50 1.533 44.459 0 38.122"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "5.402 30.615 3.861 41.002 5.094 47.301 10.189 49.049 9.737 50 2.179 50 1.533 44.458 0 38.122",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#639AEB",
    points: "8.988 23.493 11.096 18.696 7.848 13.406 8.704 10.138 13.68 16.839 16.393 18.241 19.442 22.292 30.013 26.274 29.376 28.034 18.133 26.274 15.474 28.734 11.096 29.514 6.615 29.108 .289 25.29 5.63 24.907"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "17.312 24.058 30.013 26.274 29.376 28.034 18.133 26.274 15.474 28.734 11.096 29.514 6.615 29.108 3.747 28.153 3.452 27.199 9.887 27.667 13.706 26.956",
    opacity: 0.303
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "31.987 26.956 32.938 27.132 34.611 28.755 37.079 29.164 35.963 29.89 36.569 30.607 34.707 29.89 33.84 30.141 33.996 31.387 32.512 29.735 32.216 28.659 31.433 28.516"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: "2.027 6.162 3.364 6.162 2.621 8.224 1.512 7.393"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F7D09D",
    points: ".881 18.778 1.973 13.328 4.458 8.617 5.491 2.248 11.246 0 11.788 1.061 7.479 4.202 7.461 8.65 5.42 16.171 5.099 22.855 .211 23.225"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGymnastics);
export default __webpack_public_path__ + "static/media/gymnastics.5dee010d321b132cec5e13af79252a52.svg";
export { ForwardRef as ReactComponent };